import './style.scss';

// IE11 polyfills
import 'array-from-polyfill';

import imeForm from './organisms/ime-form';
import { modals } from './organisms/modal/modals';
import { registrationConfirmation } from './molecules/modal-content/register/registration-confirmation';
import entryActions from './organisms/ime-form-entry/entry';
import { login } from './molecules/modal-content/login/login';
import { shareForm } from './molecules/modal-content/share-form/shared-form';
import { forgotPassword } from './molecules/modal-content/forgot-password/forgot-password';
import dashboard from './molecules/dashboard';
import { closeAddendumModal } from './molecules/modal-content/addendum/close-addendum-modal';
import { printContent } from './organisms/modal-ime/printContent';
import { primaryNav } from './molecules/navigation/primary-nav';
import { desktopMenu } from './molecules/navigation/desktop-menu/desktop-menu';
import { mobileMenu } from './molecules/navigation/mobile-menu/mobile-menu';
import { deleteEntry } from './molecules/ime-form-entry/delete-entry';
import { redirectToHome } from './molecules/user/redirect-to-home';
import { stickyHeader } from './organisms/header/sticky-header';
import { deleteUser } from './molecules/modal-content/form/confirm-delete-user';
import { addNewTeamMember } from './molecules/modal-content/form/add-new-team-member';
import { requestCreateTeam } from './molecules/modal-content/form/request-create-team';

/**
 * Function that is fired once the page is Ready to fire any JS, add anything
 * required to be executed after the page is ready.
 */
$( document ).ready( () => {
    imeForm();
    modals();
    registrationConfirmation();
    entryActions();
    login();
    shareForm();
    forgotPassword();
    dashboard();
    primaryNav();
    desktopMenu();
    mobileMenu();
    printContent();
    deleteEntry();
    redirectToHome();
    closeAddendumModal();
    stickyHeader();
    deleteUser();
    addNewTeamMember();
    requestCreateTeam();
});
